import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Services from "../components/site/Services";
import Philosophy from "../components/site/Philosophy";
import Gallery from "../components/site/Gallery";
import Testimonials from "../components/site/Testimonials";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import FloatingCta from "../components/site/FloatingCta";

export default function LandingPage() {
  return (
    <main className="relative bg-[#FAEDE6] text-[#1A1A1A]" data-testid="landing-page">
      <Header />
      <Hero />
      <About />
      <Services />
      <Philosophy />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
      <FloatingCta />
    </main>
  );
}
